module.exports = __webpack_public_path__ + "static/media/beach_chill.4eee0cac.svg";